import * as actionTypes from './actionTypes';

export const toggleLayerSettingsDropdown_verkenning = (key) => {
    return {
        type: actionTypes.LAYERSETTINGS_TOGGLE_VERKENNING,
        key: key
    };
};

export const initKryLayerslys_verkenning = () => {
    return {
        type: actionTypes.INIT_LAYERSLYS_VERKENNING
    };
};

export const getLayerslys_verkenning = (data) => {
    return {
        type: actionTypes.GET_LAYERSLYS_VERKENNING,
        data: data
    };
};

export const setLayerslys_verkenning = (data) => {
    return {
        type: actionTypes.SET_LAYERSLYS_VERKENNING,
        data: data
    };
};

export const getLayerslysFailed_verkenning = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSLYS_FAILED_VERKENNING,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};
export const kiesLayer_verkenning = (key) => {
    return {
        type: actionTypes.KIES_LAYER_VERKENNING,
        key: key
    };
};

export const initKryLayers_verkenning = () => {
    return {
        type: actionTypes.INIT_LAYERSAKTIEF_VERKENNING
    };
};

export const getLayers_verkenning = (data) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_VERKENNING,
        data: data
    };
};

export const setLayers_verkenning = (data) => {
    return {
        type: actionTypes.SET_LAYERSAKTIEF_VERKENNING,
        data: data
    };
};

export const getLayersFailed_verkenning = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_FAILED_VERKENNING,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const removeLayer_verkenning = (key) => {
    return {
        type: actionTypes.REMOVE_LAYER_VERKENNING,
        key: key
    };
};

export const changeLayertipe_verkenning = (key, tipe, layerkey) => {
    return {
        type: actionTypes.CHANGE_LAYERTIPE_VERKENNING,
        key: key,
        tipe: tipe,
        layerkey: layerkey
    };
};

export const changeLayerFilter_verkenning = (key, tipe, nuwewaarde) => {
    return {
        type: actionTypes.CHANGE_LAYERFILTER_VERKENNING,
        key: key,
        tipe: tipe,
        nuwewaarde: nuwewaarde
    };
};

export const setLayerEventListener_verkenning = () => {
    return (getState) => {
        console.log(getState());
        var data = [];
        const newlayersmetadata = [getState().layersmetadata.data];;
        for (var layer of newlayersmetadata) {
            for (var tipe of layer.layertipes) {
                if (tipe.active && tipe.infooverlay) {
                    if (getState().layers.data.find(obj => obj.id === layer.key)) {
                        data.push(getState().layer.data);
                    }
                }
            }
        }
        return {
            type: actionTypes.SET_LAYER_EVENTLISTENER_VERKENNING,
            data: data
        };
    }
};

export const bindEventlistener_verkenning = (mustbind) => {
    return {
        type: actionTypes.BIND_EVENTLISTENER_VERKENNING,
        mustbind: mustbind
    };
};

export const bindComponent_verkenning = () => {
    return {
        type: actionTypes.BIND_COMPONENT_VERKENNING
    };
};